import script from "./Tdefault.vue?vue&type=script&setup=true&lang=js"
export * from "./Tdefault.vue?vue&type=script&setup=true&lang=js"

import "./Tdefault.vue?vue&type=style&index=0&id=00e4d784&lang=scss"

const __exports__ = script;

export default __exports__